/* eslint-disable no-use-before-define */
import React from 'react'
import { showModal, parseJson, parseHtml, fmt} from '../twd'

export default ({html}) => {
    let ls = parseJson(parseHtml(html), {}).uwList
    if (!ls || ls.length===0) return fmt.empty()


    return <React.Fragment>
        <span dangerouslySetInnerHTML={{__html:ls[0].name}} />
        {ls.length>1 && <React.Fragment>
            &nbsp; <button
            className="link-button"
            aria-label='show more'
            onClick={(e) => {
                showModal({
                    view:'underwriter',
                    list:ls,
                    from: 'bond-detail',
                    source: e.target,
                })
            }}>+ more</button>
            </React.Fragment>}
    </React.Fragment>

}